import styles from './paper.module.scss';
import MaterialPaper from '@mui/material/Paper';

/* eslint-disable-next-line */
export interface PaperProps {
  children: any,
  // classes?: object,
  component?: any,
  elevation?: number,
  square?: boolean,
  sx?: any,
  variant?: 'elevation' | 'outlined',
  className?: string,
  ['data-testid']?: string
}

export function Paper(props: PaperProps) {
  return (
    <MaterialPaper
      variant={props.variant}
      component={props.component}
      elevation={props.elevation}
      className={props.className}
      sx={props.sx}
      square={props.square}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialPaper>
  );
}

export default Paper;